import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import debounce from 'lodash/debounce';
import { useCallback } from 'react';

export default function FreeTextSearchInput({ onChange }) {
  const debouncedOnChange = useCallback(
    debounce((value) => {
      onChange(value);
    }, 500),
    [onChange]
  );

  return (
    <TextField
      placeholder="Search..."
      variant="outlined"
      fullWidth
      onChange={(e) => debouncedOnChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ color: '#5664d2' }} />
          </InputAdornment>
        ),
        style: {
          borderRadius: 8,
          backgroundColor: '#fff',
          height: 38,
        },
      }}
      inputProps={{
        style: {
          padding: '12px',
        },
      }}
    />
  );
}
